import React, { useState } from "react";
import OrganisationCombobox from "@/components/pages/platform-admin/organisations/OrganisationCombobox";
import Organisation from "@/model/interface/Organisation";
import OrgUsageRatesSection from "./OrgUsageRatesSection";
import OrgAddOnOverridesSection from "./OrgAddOnOverridesSection";

export default function OrgCustomPricing() {
  const [selectedOrg, setSelectedOrg] = useState<Organisation | null>(null);

  return (
    <div className="space-y-6">
      <div className="space-y-1">
        <h1 className="text-2xl font-semibold">Custom Pricing</h1>
        <p className="text-sm text-muted-foreground">
          Override usage rates and add-on prices for a specific organisation. Usage overrides apply to that org's
          billing; add-on overrides create a dedicated Stripe price. Clearing reverts to the defaults.
        </p>
      </div>

      <div className="max-w-md">
        <OrganisationCombobox value={selectedOrg} onChange={setSelectedOrg} />
      </div>

      {!selectedOrg ? (
        <p className="text-sm text-muted-foreground">Select an organisation to view its pricing.</p>
      ) : (
        <div className="space-y-8">
          <OrgUsageRatesSection org={selectedOrg} />
          <OrgAddOnOverridesSection org={selectedOrg} />
        </div>
      )}
    </div>
  );
}
